/* The "Marcas" page (sections/munne-brands.liquid): fills in how many
   products each brand has, shrinks a name too long for its card, and keeps
   the alphabet bar in step with the scroll. */
(function () {
  const root = document.querySelector('[data-munne-brands]');
  if (!root) return;

  /* ---------------------------------------------------------------- Counts */

  // Liquid cannot count products per brand, so the brand of every product is
  // read page by page from the data section and tallied here.
  const readPage = (page) =>
    fetch(`${root.dataset.countsUrl}&page=${page}`)
      .then((response) => response.text())
      .then((html) => {
        const data = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-munne-brand-counts]');
        return JSON.parse(data.textContent);
      });

  const showCounts = (pages) => {
    const counts = {};
    pages.forEach((page) => page.vendors.forEach((vendor) => (counts[vendor] = (counts[vendor] || 0) + 1)));
    root.querySelectorAll('[data-munne-brand-count]').forEach((element) => {
      const count = counts[element.dataset.munneBrandCount];
      if (!count) return;
      element.textContent = `${count} ${count === 1 ? root.dataset.one : root.dataset.other}`;
    });
  };

  readPage(1)
    .then((first) => {
      const rest = [];
      for (let page = 2; page <= first.pages; page++) rest.push(readPage(page));
      return Promise.all(rest).then((others) => showCounts([first, ...others]));
    })
    .catch(() => {
      // Without counts the cards still work: name, arrow and link.
    });

  /* ----------------------------------------------------------------- Names */

  // A single long word ("BIRKENSTOCK") cannot wrap: step its size down until
  // it fits, as the mockup does, but never below 60% of the others.
  const fitNames = () => {
    root.querySelectorAll('[data-munne-brand-name]').forEach((name) => {
      name.style.fontSize = '';
      const base = parseFloat(getComputedStyle(name).fontSize);
      let size = base;
      while (name.scrollWidth > name.clientWidth && size > base * 0.6) {
        size -= 1;
        name.style.fontSize = `${size}px`;
      }
    });
  };

  fitNames();
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fitNames, 150);
  });

  /* --------------------------------------------------------------- Letters */

  const links = Array.from(root.querySelectorAll('[data-munne-brands-letter]'));
  const groups = Array.from(root.querySelectorAll('[data-munne-brands-group]'));
  const bar = root.querySelector('.munne-brands__letters');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  let shownId = null;
  const setCurrent = (id) => {
    if (id === shownId) return;
    shownId = id;
    links.forEach((link) => {
      const current = link.hash === `#${id}`;
      if (current) {
        link.setAttribute('aria-current', 'true');
        // On narrow screens the bar scrolls sideways: keep the letter in view.
        const list = link.closest('ul');
        list.scrollTo({ left: link.offsetLeft - list.offsetLeft - list.clientWidth / 2 + link.offsetWidth / 2 });
      } else {
        link.removeAttribute('aria-current');
      }
    });
  };

  links.forEach((link) => {
    link.addEventListener('click', (event) => {
      const group = document.getElementById(link.hash.slice(1));
      if (!group) return;
      event.preventDefault();
      group.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
    });
  });

  // The current letter is the last group whose top has passed under the bar;
  // none while the bar itself has not reached the header yet.
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      const line = bar.getBoundingClientRect().bottom + 2;
      const stuck = bar.getBoundingClientRect().top <= parseFloat(getComputedStyle(bar).top) + 1;
      let currentId = '';
      if (stuck) {
        groups.forEach((group) => {
          if (group.getBoundingClientRect().top <= line) currentId = group.id;
        });
      }
      setCurrent(currentId);
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
